import React from 'react';
import { Button } from '../../Button';

export interface ModalActionSpec {
  label: string;
  onClick?: () => void;
  disabled?: boolean;
  loading?: boolean;
  type?: 'button' | 'submit';
  /** Optionales führendes Icon. */
  icon?: React.ReactNode;
}

export interface ModalActionsProps {
  /** Primäraktion – rechts (Desktop) bzw. dominant (Mobile). */
  primary?: ModalActionSpec;
  /** Sekundäraktion – links/zuerst. Meist „Abbrechen"/„Schließen". */
  secondary?: ModalActionSpec;
  /** Primäraktion ist destruktiv (rote Darstellung). */
  danger?: boolean;
  /** Darstellung des Sekundär-Buttons. Standard: 'secondary' (dunkel gefüllt); 'tertiary' = weiß umrandet (wie „Löschoptionen"). */
  secondaryVariant?: 'secondary' | 'tertiary';
  /** Zusätzliche Elemente ganz links (z.B. tertiäre Aktion). */
  extra?: React.ReactNode;
}

/**
 * Einheitliche Footer-Aktionszone.
 * Desktop: sekundär links, primär rechts.
 * Mobile: gestapelt, Primäraktion visuell dominant (oben), volle Breite.
 */
export const ModalActions: React.FC<ModalActionsProps> = ({
  primary,
  secondary,
  danger = false,
  secondaryVariant = 'tertiary',
  extra,
}) => (
  <div className="flex flex-col-reverse gap-2 sm:flex-row sm:items-center sm:gap-3">
    {/* Sekundär (z.B. „Abbrechen") + optionale Extra-Aktion: Desktop linksbündig. */}
    {(secondary || extra) && (
      <div className="flex w-full flex-col-reverse gap-2 sm:w-auto sm:flex-row sm:items-center sm:gap-3">
        {extra && <span className="hidden sm:block">{extra}</span>}
        {secondary && (
          <Button
            variant={secondaryVariant}
            type={secondary.type || 'button'}
            onClick={secondary.onClick}
            disabled={secondary.disabled}
            className="min-h-[44px] w-full justify-center sm:w-auto"
          >
            {secondary.label}
          </Button>
        )}
      </div>
    )}
    {/* Primäraktion: Desktop rechtsbündig (auch wenn allein). */}
    {primary && (
      <Button
        variant={danger ? 'error' : 'primary'}
        type={primary.type || 'button'}
        onClick={primary.onClick}
        disabled={primary.disabled}
        loading={primary.loading}
        icon={primary.icon}
        className="min-h-[44px] w-full justify-center sm:ml-auto sm:w-auto"
      >
        {primary.label}
      </Button>
    )}
  </div>
);

export default ModalActions;
